import { useState } from 'react';

import type { SnippetDetails } from '../../../../../shared/snippets';

import { type SnippetConversion, snippetDetailsToSnippetConversion } from './utils';

/**
 * Hook that manages state for the ModalSnippetConversion
 */
const useModalSnippetConversion = () => {
  const [snippetConversion, setSnippetConversion] = useState<SnippetConversion | null>(null);

  // Should only be called if verifySnippetDetailsForConversion returned true
  // but if the snippet cannot be converted, this will just set the value to null.
  const convertSnippetDetails = (snippet: SnippetDetails) => {
    setSnippetConversion(snippetDetailsToSnippetConversion(snippet));
  };

  return {
    snippetConversion,
    setSnippetConversion,
    convertSnippetDetails,
  };
};

export default useModalSnippetConversion;
